<template>
  <el-dialog
    id="clone-app"
    class="align-center"
    :visible.sync="visible"
  >
    <h3>Duplicate this application on the same server ?</h3>

    <el-button
      type="primary"
      size="large"
      icon="el-icon-copy-document"
      :loading="loading"
      :disabled="!!instanceId"
      @click.prevent="clone(application.instanceId)"
    >
      Clone Application
    </el-button>

    <el-divider>OR</el-divider>

    <h3>Copy the application to another cloud server</h3>

    <el-select v-model="instanceId" filterable clearable>
      <el-option
        v-for="instance in data"
        :key="instance.id"
        :value="instance.id"
        :label="instance.name"
        :style="{ backgroundImage: 'url(' + regionFlag(instance.planId) + ')' }"
        class="clone-instance"
      />
    </el-select>

    <el-button
      type="primary"
      size="large"
      icon="el-icon-right"
      :loading="loading"
      :disabled="!instanceId"
      @click.prevent="clone(instanceId)"
    >
      Copy Application
    </el-button>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    open: Boolean,
    application: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      visible: this.open,
      instanceId: null,
      loading: false
    }
  },
  computed: {
    data () {
      return this.instances.filter((i) => i.id !== this.application.instanceId && i.state === 'running')
    },
    ...mapState(['instances'])
  },
  methods: {
    deploy () {
      this.$store.dispatch('deployApplication', {
        instanceId: this.instanceId,
        bundleId: this.bundleId,
        version: this.version
      }).then(() => this.$router.push('/instances/' + this.instanceId))
    },
    clone (targetId) {
      this.$confirm('This will create a new application. Continue?', 'Warning', {
        confirmButtonText: 'Clone',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => this.$store.dispatch('cloneApplication', { ...this.application, targetId }))
        .then(() => {
          this.$emit('update:open', false)
          this.$router.push('/instances/' + targetId)
        }).catch(() => {})
    }
  },
  watch: {
    open (value) {
      this.visible = value
      this.instanceId = null
    },
    visible (value) {
      this.$nextTick(() => this.$emit('update:open', value))
    }
  }
}
</script>

<style lang="scss">
  .clone-instance {
    background-repeat: no-repeat;
    background-position: center left 20px;
    background-size: 24px;
    padding-left: 55px;
  }
</style>

<style lang="scss" scoped>
  .el-divider {
    margin: 50px 0;
  }
  .el-select {
    display: block;
    max-width: 400px;
    margin: 0 auto 25px;
  }
</style>
